// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import {
  MessageBox,
  Toast,
} from 'mint-ui';
import 'mint-ui/lib/style.css'

import 'assets/js/flexible.js'
import 'assets/styles/common.css'
import 'assets/styles/font.scss'
import 'assets/styles/zepto.fullpage.css'

import service from './service/service.js'
import Tools from './assets/js/tool.js'
import {
  InfiniteScroll
} from 'mint-ui';

Vue.use(InfiniteScroll);



Vue.config.productionTip = false;
Vue.prototype.service = service;
Vue.prototype.toast = Toast;
Vue.prototype.tools = Tools;
Vue.prototype.alert = MessageBox;
/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})

window.app = app;



// WEBPACK FOOTER //
// ./src/main.js